import { gql } from '@urql/vue';

export interface User {
  id: any;
  username: any;
}

export interface CurrentUser extends User {
  authProvider: string;
  role: {
    isGlobalSuperAdmin: boolean;
    isGlobalAdmin: boolean;
    isGlobalOperator: boolean;
    isGlobalReadonly: boolean;
  };
  inMaintenance: boolean;
}

export const CURRENT_USER = gql`
  query CurrentUser {
    user {
      id
      username
      authProvider
      role {
        isGlobalSuperAdmin
        isGlobalAdmin
        isGlobalOperator
        isGlobalReadonly
      }
      inMaintenance
    }
  }
`;
